import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import apiUrl from '../config'; // Assurez-vous que ce fichier contient la base URL de votre API
import '../CSS/Resetpassword.css'; // Assurez-vous que ce fichier existe
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useLocation } from 'react-router-dom';



const ResetPassword = () => {
    const location = useLocation();
const params = new URLSearchParams(location.search);
const token = params.get("token");
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
          setNotification({
            open: true,
            message: 'Les mots de passe ne correspondent pas.',
            severity: 'error',
        });
            return;
        }


        try {
            const response = await axios.put(
  `${apiUrl}/reset-password?token=${token}`,
  { new_password: newPassword }
);

            if (response.status === 200) {
              setNotification({
                open: true,
                message: 'Mot de passe réinitialisé avec succès !',
                severity: 'success',
            });
                setErrorMessage('');
                setTimeout(() => {
                    window.location.href = 'https://intranet.nova-portage.com';
                }, 3000);
            }
        } catch (error) {
          setNotification({
            open: true,
            message: error.response?.data?.message || 'Erreur lors de la réinitialisation du mot de passe.',
            severity: 'error',
        });
            setSuccessMessage('');
        }
    };

    return (
        <div className="reset-password-container">
  <div className="reset-logo-container">
    <img src="/NOVA PORTAGE Main Logo.png" alt="Logo Nova Portage " className="reset-logo" />
  </div>
  <h2>Réinitialisation du mot de passe</h2>
  <form onSubmit={handleSubmit}>
    <input
      type="password"
      placeholder="Nouveau mot de passe"
      value={newPassword}
      onChange={(e) => setNewPassword(e.target.value)}
      required
    />
    <input
      type="password"
      placeholder="Confirmer le mot de passe"
      value={confirmPassword}
      onChange={(e) => setConfirmPassword(e.target.value)}
      required
    />
    {errorMessage && <p className="error-message">{errorMessage}</p>}
    {successMessage && <p className="success-message">{successMessage}</p>}
    <button type="submit">Réinitialiser le mot de passe</button>
  </form>
  <Snackbar
    open={notification.open}
    autoHideDuration={3000}
    onClose={() => setNotification({ ...notification, open: false })}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Position en haut de la page
>
    <Alert
        severity={notification.severity}
        sx={{
            width: '100%',
            fontSize: '1rem',
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
        }}
    >
        {notification.message}
    </Alert>
</Snackbar>

</div>

    );
};

export default ResetPassword;
